import React from 'react';
import { ClipLoader } from 'react-spinners';
import { useGeneralHooks } from '../../../../../../../../Hooks/hooks';
import { ImageUpload } from '../../../../../../../../Assets/Icons';
import styles from './imageUploader.module.scss';

interface IProps {
    handleFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>,
    id: string,
    loading:boolean
};


const ImageUploader: React.FC<IProps> = ({ handleFileInputChange, id ,loading}) => {
    const { t } = useGeneralHooks();
    return (
        <div className={`${styles.container} `}>
            <input
                id={id}
                type="file"
                accept="image/*"
                onChange={handleFileInputChange}
                style={{ display: "none" }}
            />
            <label htmlFor={id} className={styles.uploader}>
                <div className={styles.box}>
                    {
                        loading
                        ?
                        <ClipLoader color="#aa002b" size={50} />
                        :
                        <img src={ImageUpload} alt={'iamgeUpload.svg'} />
                    }
                </div>
                <p>
                    {t('Buttons.Upload_Image')}
                </p>
            </label>
        </div>
    )
}

export default ImageUploader
